/* nebe-ship-bar.js — lišta v hlavičce. Expediční řádek počítá sdílený nebe-ship.js,
 * tenhle soubor řeší jen text, zavírání a doladění výšky.
 *
 * Pozor na dělbu práce: jestli se lišta vůbec MÁ ukázat, rozhoduje synchronní inline skript
 * přímo v sekci (hned za lištou). Kdyby to řešil až tenhle deferovaný soubor, poskočil by
 * při každém načtení celý web. Sem patří jen to, co smí přijít o chvíli později.
 *
 * Načítá se s `defer` až za nebe-ship.js (snippet nebe-ship-i18n ho vloží dřív), takže
 * window.NEBE_SHIP je tu vždycky připravené.
 */
(function () {
  "use strict";

  // Hodnota = timestamp zavření. Klíč nese otisk znění lišty (atribut data-promo-key, počítá
  // ho sekce), takže zavřením jedné kampaně si zákazník nezavře i tu příští — musí sedět
  // s inline skriptem v nebe-ship-bar.liquid, který podle téhož klíče lištu odstraňuje.
  function keyFor(bar) {
    return "nebe:shipbar:dismissed:" + ((bar && bar.dataset.promoKey) || "0");
  }

  // Sticky hlavička, vyhledávání i slideshow počítají s --announcement-height. Sekce ji
  // emituje odhadem z Liquidu (aby se nic nehýbalo hned po načtení), tady ji srovnáme na
  // skutečnou výšku.
  //
  // Lišt je nad sebou víc (expediční slib, kreditní kampaň) a každá se ukazuje podle jiné
  // podmínky, takže se výška NIKDY nesmí brát z jedné z nich — vždycky je to součet všech,
  // které zrovna nejsou schované. Skrytá lišta má offsetHeight 0, ale hidden filtrujeme
  // i tak, ať se nespoléháme na pořadí načtení CSS.
  //
  // V selektoru je vedle [data-nebe-bar] i vlastní [data-ship-bar] jako pojistka pro případ,
  // že by sekce společný atribut nestihla dostat. querySelectorAll uzly nezdvojuje, takže
  // lišta s oběma atributy se do součtu započítá jednou.
  function measureBars() {
    var bars = document.querySelectorAll("[data-nebe-bar], [data-ship-bar]");
    var px = 0;
    for (var i = 0; i < bars.length; i++) if (!bars[i].hidden) px += bars[i].offsetHeight;
    document.documentElement.style.setProperty("--announcement-height", px + "px");
    return px;
  }

  // Vystaveno kvůli nebe-credit.js: druhá lišta musí počítat TÝMŽ součtem, jinak se dvě
  // plochy přetahují o jednu CSS proměnnou a hlavička poskakuje.
  if (!window.NEBE_BARS) window.NEBE_BARS = { measure: measureBars };

  function init(bar) {
    if (bar.dataset.shipBarReady) return; // editor motivu umí sekci vyrenderovat vícekrát
    bar.dataset.shipBarReady = "1";

    measureBars();

    dropExpiredPromo(bar);
    initCountdown(bar);

    var note = bar.querySelector("[data-ship-bar-note]");
    if (note) paintNote(bar, note, bar.dataset.pronoun);

    // Stránka může zůstat otevřená přes půlnoc, kdy promo končí — hlídá to sdílený tik.
    if (bar.dataset.promoEnd && window.NEBE_SHIP && window.NEBE_SHIP.onMinute) {
      window.NEBE_SHIP.onMinute(function () {
        if (!bar.isConnected) return false;
        return dropExpiredPromo(bar);
      });
    }

    var close = bar.querySelector("[data-ship-bar-close]");
    if (close) {
      close.addEventListener("click", function () {
        try { localStorage.setItem(keyFor(bar), String(Date.now())); } catch (e) {}
        bar.remove();
        measureBars(); // ne nula: kreditní lišta pod ní může zůstat viset dál
      });
    }

    // Bez podmínky na bar.isConnected schválně: po zavření křížkem by při otočení telefonu
    // už výšku nikdo nepřepočítal a zbylé liště by seděla hlavička na hlavě.
    window.addEventListener("resize", measureBars, { passive: true });
  }

  // Promo řádek může mít vlastní konec platnosti (věta „v pondělí zdražujeme" v pondělí lže).
  // Liquid ho po termínu nevykreslí, jenže HTML chodí z full-page cache klidně hodiny potom,
  // takže poslední slovo má prohlížeč. Měří se týmž časem jako expediční slib, ne Date() —
  // rozhoduje pražský nástěnný čas, ne hodiny na zákazníkově notebooku.
  function dropExpiredPromo(bar) {
    var S = window.NEBE_SHIP;
    var raw = bar.dataset.promoEnd;
    if (!raw || !S || !S.parseWall || !S.minutesUntil) return true;
    var target = S.parseWall(raw);
    if (!target) return true;
    var mins = S.minutesUntil(target);
    if (mins == null || mins > 0) return true; // ještě platí, zkusíme to zas za minutu

    var promo = bar.querySelector(".nebe-shipbar__promo");
    if (promo) promo.remove();
    // Bez promo řádku a bez expedičního slibu by zbyl prázdný barevný pruh s křížkem.
    if (!bar.querySelector("[data-ship-bar-note]")) bar.remove();
    measureBars();
    return false; // hotovo, odhlásit z tiku
  }

  // ---- odpočet v promo řádku --------------------------------------------------------------
  // Merchant napíše do promo textu %{t} a sekce na to místo vloží prázdný <span>. Tenhle blok
  // do něj sype zbývající čas — v posledních 24 hodinách po setinách vteřiny, aby byl termín
  // vidět jako ubíhající čas, ne jako datum.
  //
  // Tři pravidla, na kterých to celé stojí:
  //   1. Píše se JEN do slotu, přes textContent. Promo řádek obsahuje SVG tah podtržení
  //      z highlight-text; přepisovat kvůli číslu celý řádek by znamenalo překreslovat ten tah
  //      třicetkrát za vteřinu.
  //   2. Šířka slotu je rezervovaná v CSS podle režimu (atribut data-cd-mode), takže se při
  //      tikání nehýbe zalomení věty.
  //   3. Smyčka běží jen tehdy, když má komu tikat: ne ve skrytém tabu, ne po odscrollování
  //      lišty z obrazovky, a na slabém zařízení se sama zahodí ve prospěch tikotu po vteřinách.

  var NB = " ";
  var DAY_MS = 86400000;

  function czWord(n, one, few, many) {
    return n === 1 ? one : (n >= 2 && n <= 4 ? few : many);
  }
  function pad2(n) { return (n < 10 ? "0" : "") + n; }

  // Ladicí přebití termínu, stejná konvence jako ?ship= v nebe-ship.js a ?d=mobile v nebe-pdp.js:
  // ?promoend=2026-08-31T00:00. Bez něj se všechny čtyři režimy dají prohlédnout jen čekáním.
  function promoEndOverride() {
    try {
      var m = new RegExp("[?&]promoend=([^&]+)").exec(window.location.search);
      return m ? decodeURIComponent(m[1]) : "";
    } catch (e) { return ""; }
  }

  /* Zbývající čas do podoby, jaká jde do lišty. Zkratky jednotek schválně: verzálkový řádek
   * s prostrkáním je na mobilu tak akorát široký a „1 h 30 min" ušetří proti „1 hodinu a
   * 30 minut" skoro dvacet znaků. Vteřiny a minuty jsou dvoumístné, jakmile mají před sebou
   * vyšší jednotku — jinak by se šířka měnila při každém přeskoku přes desítku.
   *   coarse = true → bez setin (slabé zařízení nebo vypnuté animace)
   * Vrací i jméno režimu, podle kterého si CSS rezervuje šířku slotu.
   */
  function formatLeft(ms, coarse) {
    if (ms < 0) ms = 0;
    var d = Math.floor(ms / DAY_MS);
    var h = Math.floor(ms / 3600000) % 24;
    var m = Math.floor(ms / 60000) % 60;
    var sec = Math.floor(ms / 1000) % 60;
    var cs = Math.floor(ms / 10) % 100;
    // I samotné vteřiny jsou dvoumístné: bez toho by se text při přechodu přes desítku
    // zkrátil o znak a celý vycentrovaný řádek by poskočil.
    var s = coarse ? pad2(sec) + NB + "s" : pad2(sec) + "," + pad2(cs) + NB + "s";

    // Nad den nemá cenu tikat po setinách: číslo, které se hýbe, je stejně jen to poslední,
    // a „2 dny 5 h 12 min 20,20 s" je řádek, který se na mobilu nevejde nikam.
    if (d > 0) {
      return { mode: "dhm", text: d + NB + czWord(d, "den", "dny", "dní") + " " + h + NB + "h " + m + NB + "min" };
    }
    if (h > 0) return { mode: "hms", text: h + NB + "h " + pad2(m) + NB + "min " + (coarse ? pad2(sec) + NB + "s" : pad2(sec) + "," + pad2(cs) + NB + "s") };
    if (m > 0) return { mode: "ms", text: m + NB + "min " + (coarse ? pad2(sec) + NB + "s" : pad2(sec) + "," + pad2(cs) + NB + "s") };
    return { mode: "s", text: s };
  }

  /* Znění pro čtečku obrazovky. Tikající číslo se odposlechnout nedá, takže vedle viditelného
   * řádku stojí druhý, schovaný, s hrubým časem a plnými slovy — a hlavně ve tvaru, který sedí
   * za předložku „za" (za 1 hodinu, za 2 hodiny, za 5 hodin).
   * Přepisuje se jen jednou za minutu; aria-live tu není schválně, ta by mluvila pořád.
   */
  function coarseWords(ms) {
    if (ms < 0) ms = 0;
    var d = Math.floor(ms / DAY_MS);
    var h = Math.floor(ms / 3600000) % 24;
    var m = Math.floor(ms / 60000) % 60;
    var mm = m + NB + czWord(m, "minutu", "minuty", "minut");
    var hh = h + NB + czWord(h, "hodinu", "hodiny", "hodin");
    if (d > 0) return d + NB + czWord(d, "den", "dny", "dní") + ", " + hh + " a " + mm;
    if (h > 0) return hh + " a " + mm;
    if (m > 0) return mm;
    return "necelou minutu";
  }

  // Emoji nesou v promo textu význam pro oko („🔥 Poslední kusy"), ale čtečka je čte jako
  // název znaku. Pro odposlech si proto stavíme holou variantu. Regexy stejné jako
  // stripEmoji v nebe-credit.js — ta je zavřená ve vlastní IIFE a lišta na ni nedosáhne.
  function stripEmoji(str) {
    return String(str || "")
      .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "")
      .replace(/[←-⇿⌀-⏿☀-➿⬀-⯿️⃣〰〽]/g, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  }

  function initCountdown(bar) {
    var slot = bar.querySelector("[data-promo-cd]");
    if (!slot) return; // promo text bez %{t} — není co počítat

    var S = window.NEBE_SHIP;
    var raw = promoEndOverride() || bar.dataset.promoEnd;
    var wall = S && S.parseWall ? S.parseWall(raw) : null;
    var target = wall && S.epochOf ? S.epochOf(wall) : null;
    // Bez platného termínu se nespouští nic. Sekce takový případ nevykreslí (viz podmínka
    // has_countdown v nebe-ship-bar.liquid), tohle je pojistka pro cache se starým HTML.
    if (!target) return;

    var sr = bar.querySelector("[data-promo-sr]");
    var tpl = bar.dataset.promoTpl || "";
    var lastText = "", lastMode = "", lastSr = "";
    var stopFrame = null;

    function left() { return target - Date.now(); }

    function paint(coarse) {
      var ms = left();
      if (ms <= 0) { finish(); return false; }

      var out = formatLeft(ms, coarse);
      if (out.mode !== lastMode) {
        // Atribut řídí rezervovanou šířku slotu v CSS. Mění se čtyřikrát za celou kampaň,
        // takže je to jediný okamžik, kdy se šířka řádku vůbec smí hnout.
        slot.setAttribute("data-cd-mode", out.mode);
        lastMode = out.mode;
      }
      if (out.text !== lastText) {
        // Číslice sázíme do pevné mřížky (viz paintDigits v nebe-ship.js) — značkový font
        // nemá tabulární číslice, takže by se šířka řádku měnila s každou setinou.
        if (S.paintDigits) S.paintDigits(slot, out.text); else slot.textContent = out.text;
        lastText = out.text;
      }
      return true;
    }

    // Vteřiny do textu pro čtečku nepatří, takže stačí minutový tik sdílený s expedičním slibem.
    function paintSr() {
      if (!sr || !tpl) return;
      var txt = stripEmoji(tpl).split("%{t}").join(coarseWords(left()));
      if (txt !== lastSr) { sr.textContent = txt; lastSr = txt; }
    }

    function finish() {
      if (stopFrame) { stopFrame(); stopFrame = null; }
      // Skrytí po doběhnutí termínu řeší jedno jediné místo — tohle je jen přesnější spoušť
      // než minutový tik: promo řádek zmizí v ten okamžik, kdy odpočet dojede na nulu.
      dropExpiredPromo(bar);
    }

    // Nad 24 hodin se jemná smyčka vůbec nespouští: mění se jen minuty a na ty je tu sdílený
    // minutový tik. Zapne se sama, jakmile zbývání spadne pod den.
    function run() {
      if (!slot.isConnected) return;
      var ms = left();
      if (ms <= 0) { finish(); return; }
      if (ms >= DAY_MS || stopFrame || !S.onFrame) return;
      stopFrame = S.onFrame(paint, { watch: bar });
    }

    paint(S.isCoarse ? S.isCoarse() : false);
    paintSr();
    run();

    if (S.onMinute) {
      S.onMinute(function () {
        if (!slot.isConnected) return false;
        paintSr();
        // Minutový tik je zároveň jediné, co kreslí odpočet v režimu nad 24 hodin.
        if (!stopFrame) { if (!paint(true)) return false; run(); }
      });
    }
  }

  // pronoun sjednotí rod slibu s promo řádkem nad ním: „Poslední podprsenky … je máš zítra",
  // ne „… to máš zítra". Na PDP se nepředává, tam zůstává obecné „to".
  function paintNote(bar, note, pronoun) {
    if (!window.NEBE_SHIP) { note.hidden = true; return; }

    var last = null;
    function paint() {
      var txt = "";
      try { txt = window.NEBE_SHIP.text({ surface: "bar", pronoun: pronoun }); } catch (e) { txt = ""; }
      if (txt === last) return;
      last = txt;
      // prázdno = slib je vypnutý (vyprázdněné klíče ship_* v locales) → řádek zmizí,
      // ale lišta zůstane kvůli promo sdělení nad ním
      note.hidden = !txt;
      note.innerHTML = txt;
      measureBars();
    }
    paint();

    // Minutový tik ze sdíleného modulu — stejný, který pohání řádek na PDP, takže se obě
    // plochy překlopí naráz. Ve 14:00 se nemění číslo, ale celá věta, proto plný přepočet.
    if (window.NEBE_SHIP.onMinute) {
      window.NEBE_SHIP.onMinute(function () {
        if (!note.isConnected) return false;
        paint();
      });
    }
  }

  function boot() {
    var bar = document.querySelector("[data-ship-bar]");
    if (bar) init(bar);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  // editor motivu: po přerenderování sekce se musí navázat znovu
  document.addEventListener("shopify:section:load", boot);
})();
